import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  layoutRootView: {
    flexGrow: 1,
    flexDirection: 'column',
    backgroundColor: 'white',
    justifyContent: 'center',
    overflowY: 'auto',
    height: '100%',
  },
})
